/**
 * Defualt options for text-to-svg convert
 * @see https://github.com/shrhdk/text-to-svg
 */
const TEXT_TRANSFORM_DEFAULTS = {
    x: 0,
    y: 0,
    kerning: true,
    tracking: false,
    anchor: 'top'
};

module.exports = {
    TEXT_TRANSFORM_DEFAULTS
};
